import type { RaRecord } from "react-admin";

export type LagatReceiptRow = RaRecord & {
  name?: string;
  itsNo?: string;
  amount?: number;
  paymentMode?: string;
  purpose?: string;
  purposeName?: string;
  receiptDate?: string;
  remarks?: string;
};

export const DEFAULT_PAYMENT_MODE_FILTER = "CASH";

export const PAYMENT_MODE_OPTIONS = [
  { id: "CASH", name: "CASH" },
  { id: "ONLINE", name: "ONLINE" },
  { id: "CHEQUE", name: "CHEQUE" },
];

export const purposeLabel = (record: LagatReceiptRow) =>
  record.purposeName || record.purpose || "—";

export const openReceiptPrint = (id: string | number) => {
  window.open(`#/lagat-rcpt/${id}`, "_blank");
};

export const getFilterFromURL = () => {
  const fallback = { paymentMode: DEFAULT_PAYMENT_MODE_FILTER };
  if (typeof window === "undefined") return fallback;

  const filterParam = new URLSearchParams(window.location.search).get("filter");
  if (!filterParam) return fallback;

  try {
    const parsed = JSON.parse(filterParam) as Record<string, unknown>;
    return {
      ...parsed,
      paymentMode: (parsed.paymentMode as string) || DEFAULT_PAYMENT_MODE_FILTER,
    };
  } catch {
    return fallback;
  }
};

export const lagatExportFilenameSuffix = (paymentMode?: string) => {
  const tab = PAYMENT_MODE_OPTIONS.find((option) => option.id === paymentMode);
  if (tab?.name) {
    return tab.name.toLowerCase().replace(/\s+/g, "").replace(/-/g, "");
  }
  return paymentMode?.toLowerCase() || "lagatreceipts";
};
